import {
    Account,
    Auditable,
    BaseTissue,
    Lockable,
    Order,
    Procedure,
    QueryParams,
    Shipment,
    SortParams,
    Surgery,
    TissueOffer,
    TissueProcedure,
    TissueType,
} from "..";

export interface TissueDetail extends Auditable, Lockable {
    data: any;
}

export interface TissuePlacement extends TissueDetail {
    tissueId: number;
    tissueUse?: string;
    postOpFollowupSentById?: number;
    postOpFollowupSentOn?: string;
    requestorAccountId?: number;
    feeResearchPrepay?: number;
    feeTissueFee?: number;
    feeShippingFee?: number;
    feeProcessingFee?: number;
    feeProcessingFee2?: number;
    apInvoiceNumber?: string;
    apInvoiceTissueFee?: number;
    apInvoiceProcessingFee: number;
    apInvoiceShippingFee: number;
    procedureId?: number;
    procedure2Id?: number;
    originalMedium?: string;
    originalOtherMedium?: string;
    originalLotNo?: string;
    originalExpDate?: string;

    reasonTissuesWereNotReleased?: string;
    transportationIssue?: boolean;
    surgeonIssue?: boolean;
    recipientIssue?: boolean;
    returnedAndUnableToReplace?: boolean;
    donorInfoNotAvailable?: boolean;
    expiredOrUnableToPlace?: boolean;
    damagedDuringProcessing?: boolean;
    otherReasonAfterRelease?: boolean;

    procedure?: Procedure;
    procedure2?: Procedure;
}

export interface InitialEval extends TissueDetail {
    tissueId: number;
    isSuitableForTransplant?: boolean;
    reasonTissuesWereNotReleased?: string;
    transportationIssue?: boolean;
    surgeonIssue?: boolean;
    recipientIssue?: boolean;
    returnedAndUnableToReplace?: boolean;
    donorInfoNotAvailable?: boolean;
    expiredOrUnableToPlace?: boolean;
    damagedDuringProcessing?: boolean;
    otherReasonAfterRelease?: boolean;
    signedByUserId?: number;
    signedByName?: string;
    signedByTerritoryLabel?: string;
    signedOn?: string;
}

export interface PostProcedureEval extends TissueDetail {
    tissueProcedureId: number;
    isSuitableForTransplant?: boolean;
    signedByUserId?: number;
    signedByName?: string;
    signedByTerritoryLabel?: string;
    signedOn?: string;

    tissueProcedure?: TissueProcedure;
}

export interface PostopFollowupRequest {
    tissueId: string;
    pin: number;
}

export interface Tissue extends Auditable {
    caseId: number;
    baseTissueId?: number;
    tissueTypeId?: number;
    accountId?: number;
    sourceAccountId?: number; // if imported from another eye bank
    potentialSurgeryId?: number;
    isImported: boolean;
    isShippedDirect: boolean;
    number: string; // e.g. A24-0001-C-OD
    side: string; // OD | OS
    parentTissueNumber?: string;
    data: any;

    version: number;
    isOriginal: boolean;
    isQuarantined: boolean;
    isClearedForTransplant: boolean;
    isDistributed: boolean;
    isHiddenFromDistroDashboard: boolean;
    isProcessReturn: boolean;
    hasBeenReturned: boolean; // once true always true
    din?: string;

    tissueType?: TissueType;
    baseTissue?: BaseTissue;
    account?: Account;
    sourceAccount?: Account;
    initialEval?: InitialEval;
    placement?: TissuePlacement;
    tissueProcedures?: TissueProcedure[];
    shipments?: Shipment[];
    orders?: Order[];
    surgery?: Surgery;
    backupSurgery?: Surgery;
    potentialSurgery?: Surgery;
    invoiceIds?: number[];
    offers?: TissueOffer[];
    importedById?: number;
    importedOn?: string;
    exportedToPobOn?: string;
    daughterTissueIndex?: string;
    recoveredOnUtc?: string;
    presToSurgeryDays?: number;
}

export const DefaultTissueQueryParams: QueryParams = {
    number: "",
};

export const DefaultTissueSortParams: SortParams = {
    orderBy: "number",
    orderDesc: "false",
};

export interface DaughterTissue {
    daughterTissueType: string;
    daughterTissueOs: boolean;
    daughterTissueOd: boolean;
    daughterTissueVolOs: string;
    daughterTissueVolOd: string;
    daughterTissueVolUnitOs: string;
    daughterTissueVolUnitOd: string;
    daughterTissueIndex: string;
}
